import { render, staticRenderFns } from "./PlansComponent.vue?vue&type=template&id=f3990ece&scoped=true"
import script from "./PlansComponent.vue?vue&type=script&lang=js"
export * from "./PlansComponent.vue?vue&type=script&lang=js"
import style0 from "./PlansComponent.vue?vue&type=style&index=0&id=f3990ece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3990ece",
  null
  
)

export default component.exports